// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a3dXiFj2Ggt2aHW0EWfO{display:flex;flex-direction:column;row-gap:30px}.a3dXiFj2Ggt2aHW0EWfO td:nth-child(3){width:650px}.wEa9iV2ch1AMqETtU9bF{align-self:flex-end}`, "",{"version":3,"sources":["webpack://./modules/RsoSettings/RsoSettings.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,YAAA,CAEA,sCACE,WAAA,CAIJ,sBACE,mBAAA","sourcesContent":[".form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 30px;\r\n\r\n  td:nth-child(3) {\r\n    width: 650px;\r\n  }\r\n}\r\n\r\n.button {\r\n  align-self: flex-end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `a3dXiFj2Ggt2aHW0EWfO`,
	"button": `wEa9iV2ch1AMqETtU9bF`
};
export default ___CSS_LOADER_EXPORT___;
